import { render, staticRenderFns } from "./WithPopup.vue?vue&type=template&id=51ac0c57&"
import script from "./WithPopup.vue?vue&type=script&lang=js&"
export * from "./WithPopup.vue?vue&type=script&lang=js&"
import style0 from "./WithPopup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports